import {
  TEntityResponse,
  TEntityListResponse,
  TDeviceProfileEventResBody,
  TDeviceProfileEventSummaryResBody,
} from '@poseidon-city/shared';

import { TAPIClient } from '../client';

type TDeviceProfileEventsClient = {
  get(id: string): Promise<TEntityResponse<'device-profile-event', TDeviceProfileEventResBody> | undefined>;
  list(
    limit: number,
    page: number
  ): Promise<TEntityListResponse<'device-profile-event', TDeviceProfileEventSummaryResBody> | undefined>;
};

function DeviceProfileEventsClient(apiClient: TAPIClient): TDeviceProfileEventsClient {
  return {
    async get(id: string): Promise<TEntityResponse<'device-profile-event', TDeviceProfileEventResBody> | undefined> {
      const data = await apiClient.get<TEntityResponse<'device-profile-event', TDeviceProfileEventResBody>>(
        `/device-profile-events/${id}`
      );

      if (data && data.type !== 'device-profile-event') {
        throw new Error('Invalid entity type received, expected: device-profile-event, received: ' + data.type);
      }

      return data;
    },
    async list(
      limit: number,
      page: number
    ): Promise<TEntityListResponse<'device-profile-event', TDeviceProfileEventSummaryResBody> | undefined> {
      const data = await apiClient.get<TEntityListResponse<'device-profile-event', TDeviceProfileEventSummaryResBody>>(
        `/device-profile-events?limit=${limit}&page=${page}`
      );

      if (data && data.type !== 'device-profile-event') {
        throw new Error('Invalid entity type received, expected: device-profile-event, received: ' + data.type);
      }

      return data;
    },
  };
}

export { TDeviceProfileEventsClient, DeviceProfileEventsClient };
